import { render, staticRenderFns } from "./video_square.vue?vue&type=template&id=cdaea09c&scoped=true"
import script from "./video_square.vue?vue&type=script&lang=js"
export * from "./video_square.vue?vue&type=script&lang=js"
import style0 from "./video_square.vue?vue&type=style&index=0&id=cdaea09c&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdaea09c",
  null
  
)

export default component.exports